import { render, staticRenderFns } from "./RegisterPage2.vue?vue&type=template&id=2184c42d&"
import script from "./RegisterPage2.vue?vue&type=script&lang=js&"
export * from "./RegisterPage2.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPage2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports